import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { PhoneNumberType, PhoneNumberUtil } from 'google-libphonenumber';

export function MobilePhoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    let number;
    try {
      number = PhoneNumberUtil.getInstance().parseAndKeepRawInput(control.value);
    } catch {
      return {invalidPhoneNumber: true};
    }

    if (!PhoneNumberUtil.getInstance().isValidNumber(number)) {
      return {invalidPhoneNumber: true};
    }

    const numberType = PhoneNumberUtil.getInstance().getNumberType(number);
    if (numberType !== PhoneNumberType.MOBILE && numberType !== PhoneNumberType.FIXED_LINE_OR_MOBILE) {
      return {notMobilePhoneNumber: true};
    }

    return null;
  };
}
